import type { ComponentProps, PropsWithChildren } from 'react'
import { GuideFusuma } from '~/components/modal/GuideFusuma'
import { useIsPC } from '~/lib/ua'

type Props = Pick<ComponentProps<typeof GuideFusuma>, 'bodyClassName'>

export function GuideAccess({ bodyClassName, children }: PropsWithChildren<Props>) {
  const pc = useIsPC()
  return (
    <GuideFusuma
      title="アクセス"
      bodyClassName={bodyClassName}
      headerColor={pc ? 'white' : 'neutral'}
    >
      {children}
    </GuideFusuma>
  )
}
